var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"policy-page"},[_c('h1',[_vm._v("商务诚信法规")]),_c('policy-list',{attrs:{"list":_vm.employmentList},on:{"item-click":_vm.handlePolicyClick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }